const Home = () => (
    <div className="about-page">
        <div className="home-header">
            <div className="typed-container home-typed-container">
                <h1 className='typed-out'>
                    Hi, I'm Eli Morse!
                </h1>
                <h1 className='static'>
                    Hi, I'm Eli Morse!
                </h1>
            </div>
        </div>
        <div className="home-container">
            <div className="home-left">
                <p className="home-text">
                    I am a Software Developer IV at Paycom, where I contribute to innovative in-house testing software solutions using C#/.NET.
                    I hold a degree in Software Engineering from the University of Central Oklahoma, where I also supported students as a Mathematics Tutor for over three years.
                </p>
                <p>
                    My inquisitive nature leads me to spending much of my free time learning about various topics and developing new skills.
                    A few of my interests include: software architecture and design, linguistics, mathematics, music, and technology.
                </p>
                <p>
                    As a well-organized, self-driven, and team-oriented individual, I pride myself on problem solving skills and attention to detail.
                </p>
            </div>
            <div className="home-right">
                <ul className="experience-list">
                    <li>
                        Experience:
                        <ul className="experience-sublist">
                            <li>
                                C# / ASP.NET / PHP / MySQL / TS / JS / HTML / CSS / React / C
                            </li>
                            <li>
                                Software Architecture And Design
                            </li>
                            <li>
                                Applications Database Systems
                            </li>
                            <li>
                                Object-Oriented Design and Patterns
                            </li>
                            <li>
                                Software Engineering I & II
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

        </div>
    </div>
);

export default Home;